import { Status } from '../../types/data.types';
import { OrderActionTypes } from './order.types';

const initialState: WebOrder.State.Order = {
  history: {
    status: 'pending',
  },
  reorders: {
    collectionReorders: { status: Status.LOADING },
    deliveryReorders: { status: Status.LOADING },
    restaurantCollectionReorders: {},
    restaurantDeliveryReorders: {},
  },
  unavailableReorderItems: [],
};

export const orderReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: WebOrder.State.Order = initialState,
  action: OrderActionTypes,
): WebOrder.State.Order => {
  switch (action.type) {
    case 'SET_ORDER_HISTORY': {
      return {
        ...state,
        history: action.payload,
      };
    }

    case 'SET_REORDER_ORDER_ID': {
      return {
        ...state,
        reorderOrderId: action.payload,
      };
    }

    case 'SET_REORDERS': {
      if (
        action.payload.reorderType === 'restaurantCollectionReorders' ||
        action.payload.reorderType === 'restaurantDeliveryReorders'
      ) {
        const { prId } = action.payload;
        return {
          ...state,
          reorders: {
            ...state.reorders,
            [action.payload.reorderType]: {
              ...state.reorders.restaurantCollectionReorders,
              [prId]: action.payload.reorders,
            },
          },
        };
      }

      return {
        ...state,
        reorders: {
          ...state.reorders,
          [action.payload.reorderType]: action.payload.reorders,
        },
      };
    }

    case 'SET_UNAVAILABLE_REORDER_ITEMS': {
      return {
        ...state,
        unavailableReorderItems: action.payload,
      };
    }

    default:
      return state;
  }
};
